import { Collection } from 'modules/core/lib/mobx-rest'

import Presence from 'modules/attendance/store/models/Presence'
import type Employee from 'modules/employees/store/models/Employee'

class Presences extends Collection<Presence> {
  get cacheKey(): string {
    return 'presences'
  }

  model() {
    return Presence
  }

  get primaryKey(): string {
    return 'employee_id'
  }
}

const singleton: Presences = new Presences()

export const employeePresence = (employee: Employee): Presence => {
  const id = employee.attributes.id

  return (
    singleton.find({
      employee_id: id,
    }) || Presence.getNull(id)
  )
}

export const employeeClockedIn = (employee: Employee): boolean => {
  return employeePresence(employee).attributes.clocked_in
}

export default singleton
